import { createContext, useContext, useMemo, ReactNode } from 'react';

import { PendingFlushCoordinator } from '../services/PendingFlushCoordinator';
import { useAutoSavingService } from './AutoSavingServiceContext';

const PendingFlushCoordinatorContext = createContext<PendingFlushCoordinator | undefined>(
  undefined,
);

export function PendingFlushCoordinatorProvider({ children }: { children: ReactNode }) {
  const autoSaving = useAutoSavingService();
  const coordinator = useMemo(() => new PendingFlushCoordinator(autoSaving), [autoSaving]);
  return (
    <PendingFlushCoordinatorContext.Provider value={coordinator}>
      {children}
    </PendingFlushCoordinatorContext.Provider>
  );
}

export function usePendingFlushCoordinator(): PendingFlushCoordinator {
  const context = useContext(PendingFlushCoordinatorContext);
  if (!context) {
    throw new Error(
      'usePendingFlushCoordinator must be used within PendingFlushCoordinatorProvider',
    );
  }
  return context;
}
